<template>
  <div class="w-100">
    <template>
      <div class="row">
        <div class="col-12">
          <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
            <h2 class="card-title font-weight-bolder">{{ $t('title.stats') }}</h2>
          </div>
        </div>
      </div>
      <div v-if="!isBusy && player && player.statistics" class="row mt-2">
        <div class="col-12">
          <div class="questions sygni-grid">
            <div class="">
              <div class="row filters">
                <div class="col-6">
                  <template>
                    <table class="table table-striped table-sm">
                      <tbody>
                        <tr class="bg-dark">
                          <td class="font-weight-bolder">{{ $t('table.label.stats.conversion_time') }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>{{ $t('table.label.stats.registration_date') }}</td>
                          <td>{{ player.statistics.registrationDate | dateFormatUTC }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('table.label.stats.first_deposit_date') }}</td>
                          <td>{{ player.statistics.firstDepositDate | dateFormatUTC }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('table.label.stats.conversion_time') }}</td>
                          <td>{{ player.statistics.conversionTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </div>
                <div class="col-6">

                  <b-form-group
                      :label="$t('stats.date_range')"
                      label-for="validTo"
                      label-cols-lg="3"
                  >
                    <date-range-picker v-model="dateRange"
                                       ref="picker"
                                       :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                                       :auto="false"
                                       :linked="false"
                                       style="width: 100%;"
                                       :show-week-numbers="false"
                                       :time-picker="false"
                                       filter-name="createdAt"
                                       :auto-apply="true"
                                       :opens="'center'"
                                       :label="$t('filters.label.created_at')"
                                       :timePicker24Hour="false">
                      <template v-slot:input="picker" style="width: 1350px;">
                        {{ picker.startDate | dateFormat }} - {{ picker.endDate | dateFormat }}
                      </template>
                    </date-range-picker>

                    <b-icon-x-circle v-if="dateRange.startDate != null" variant="danger"
                                     @click="arguments[0].stopPropagation(); clearDate()"
                                     style="top: 0;"
                                     >
                    </b-icon-x-circle>
                    <b-icon-calendar3 v-if="dateRange.startDate === null"
                                      @click="arguments[0].stopPropagation(); $refs.picker.togglePicker(true/false)"
                                      style="top: 0">
                    </b-icon-calendar3>
                  </b-form-group>
                  <div class="w-100 mt-2 text-right">
                    <b-button @click="getStatistics()" variant="primary">{{$t('btn.statistics.apply')}}</b-button>
                  </div>
                </div>
              </div>
            </div> <!-- #card-body-->
          </div> <!-- #card questions sygni-grid-->
        </div>
      </div>

      <div v-if="!isBusy && player && player.statistics" class="row mt-2">
        <div class="col-12">
          <div class="questions sygni-grid">
            <div class="">
              <div class="row filters">
                <div class="col-6">
                  <template>
                    <table class="table table-striped table-sm">
                      <tbody>
                        <tr class="quiz-coins">
                          <td class="font-weight-bolder">{{ $t('table.label.stats.quiz_coins') }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>{{ $t('table.label.stats.total_deposit_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.totalDepositsNumber }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('table.label.stats.total_deposits_amount') }}</td>
                          <td>{{ player.statistics.quizCoinStats.totalDepositsAmount }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bolder">{{ $t('table.label.stats.games_played_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.gamesPlayedNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.first_place_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.firstPlaceNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.second_place_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.secondPlaceNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.third_place_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.thirdPlaceNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.fourth_place_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.fourthPlaceNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.last_game') }}</td>
                          <td>{{ player.statistics.quizCoinStats.lastGame | dateFormatUTC }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.wins_amount') }}</td>
                          <td>{{ player.statistics.quizCoinStats.winsAmount }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bolder">{{ $t('table.label.stats.tournaments_played_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.tournamentsPlayedNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.tournaments_awards_number') }}</td>
                          <td>{{ player.statistics.quizCoinStats.tournamentsAwardsNumber }}</td>
                        </tr>
                        <tr>
                          <td class="pl-4">{{ $t('table.label.stats.tournaments_awards_amount') }}</td>
                          <td>{{ player.statistics.quizCoinStats.tournamentsAwardsAmount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </div>

                <div class="col-6">
                  <template>
                    <table class="table table-striped table-sm">
                      <tbody>
                      <tr class="free-coins">
                        <td class="font-weight-bolder">{{ $t('table.label.stats.free_coins') }}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>{{ $t('table.label.stats.total_deposit_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.totalDepositsNumber }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('table.label.stats.total_deposits_amount') }}</td>
                        <td>{{ player.statistics.funCoinStats.totalDepositsAmount }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bolder">{{ $t('table.label.stats.games_played_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.gamesPlayedNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.first_place_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.firstPlaceNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.second_place_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.secondPlaceNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.third_place_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.thirdPlaceNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.fourth_place_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.fourthPlaceNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.last_game') }}</td>
                        <td>{{ player.statistics.funCoinStats.lastGame | dateFormatUTC }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.wins_amount') }}</td>
                        <td>{{ player.statistics.funCoinStats.winsAmount }}</td>
                      </tr>

                      <tr>
                        <td class="font-weight-bolder">{{ $t('table.label.stats.tournaments_played_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.tournamentsPlayedNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.tournaments_awards_number') }}</td>
                        <td>{{ player.statistics.funCoinStats.tournamentsAwardsNumber }}</td>
                      </tr>
                      <tr>
                        <td class="pl-4">{{ $t('table.label.stats.tournaments_awards_amount') }}</td>
                        <td>{{ player.statistics.funCoinStats.tournamentsAwardsAmount }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </template>
                </div>
              </div>
            </div> <!-- #card-body-->
          </div> <!-- #card questions sygni-grid-->
        </div>
      </div>
    </template>
    <div v-if="isBusy || !player || !player.statistics" class="spinner-wrapper">
      <b-spinner></b-spinner>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";

export default {
  components: {
    DateRangePicker
  },
  data() {
    return {
      isBusy: false,
      dateRange: {
        startDate: null,
        endDate: null
      },
    };
  },
  mounted() {
    this.getStatistics();
  },
  methods: {
    getStatistics() {
      this.isBusy = true;

      const userIdFromUrl = this.$route.params.id;
      const dateFrom = this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : null;
      const dateTo = this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : null;

      const payload = {
        id: userIdFromUrl,
        dateFrom: dateFrom,
        dateTo: dateTo
      }

      this.$store.dispatch('players/getPlayerStatistics', payload).then(() => {
        this.isBusy = false;
      });
    },
    clearDate() {
      this.dateRange = {
        startDate: null,
        endDate: null
      };
    }
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    }
  }
}
</script>
